// https://github.com/brohlson/gatsby-plugin-anchor-links/blob/master/src/components/AnchorLink.js
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import scroller from '../../utils/scroller'
import copy from 'copy-to-clipboard'

export const isBrowser = typeof window !== 'undefined'

export const isDevelopment = process.env.NODE_ENV !== 'production'

const handleLinkClick = (to, e) => {
	if (isBrowser && to.includes('#')) {
		const [anchorPath, anchor] = to.split('#')
		if (window.location.pathname === anchorPath || !anchorPath) {
			e.preventDefault()
			scroller(anchor, -140)
			window.history.replaceState({}, '', `#${anchor}`)
		}

		const url = new URL(to, window.location.href)
		copy(url)
	}
}

const AnchorLink = ({ to, children, className, onClick }) => (
	/* Gatsby link resolves the "to" to an absolute link. However, it completely ignores query parameters which causes some issues.
		Using a simple anchor works best here.
	*/
	<a
		href={to}
		onClick={e => {
			handleLinkClick(to, e)
			onClick?.(e)
		}}
		className={className}
	>
		{children}
	</a>
)

AnchorLink.propTypes = {
	to: PropTypes.string.isRequired,
	className: PropTypes.string,
	children: PropTypes.node,
}

export default AnchorLink
